<template>
    <div
        class="md-hero broker"
        :class="[`banner-with-${searchStyle}`]"
        :style="{ marginBottom }"
    >
        <banner
            ref="banner"
            :type="type"
            :mobileType="mobileType"
            :useMobileSettings="useMobileSettings"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :mobilePicture="mobilePicture"
            :pictureListOption="pictureListOption"
            :mobilePictureListOption="mobilePictureListOption"
            :maskOption="maskOption"
            :videoOption="videoOption"
            :mobileVideoOption="mobileVideoOption"
        >
            <media-content
                :class="`f-col media-content-${searchStyle} ${
                    titleAlign ? 'align-' + titleAlign : ''
                }`"
                :type="contentType"
                :title="title"
                :subTitle="subTitle"
                :imgAlign="imgAlign"
                :titlePic="titlePic"
                :showShadow="showShadow"
                :layout="searchBarLayout"
                class="row2column"
            >
                <template #info>
                    <div
                        v-if="useType === 'video'"
                        class="play-video"
                        @click="doVideoPlay"
                    ></div>
                </template>
                <div v-if="useType === 'video'" class="video-loading"></div>
                <div class="media-content-box" @click="avoidEmitMedia">
                    <search-group
                        v-if="searchStyle === 'search-group'"
                        :needSearchCondition="false"
                        :searchGroupTabs="searchGroupTabs"
                        :searchGroupConfig="searchGroupConfig"
                        :nameType="nameType"
                        :nameRequired="nameRequired"
                        :phoneRequired="phoneRequired"
                        :class="searchBarLayout"
                        class="row2column"
                        :agreementData="agreementData"
                    ></search-group>
                    <banner-button
                        v-if="searchStyle === 'search-btn'"
                        :buttons="buttons"
                        :class="searchBarLayout"
                        class="row2column"
                    >
                    </banner-button>
                </div>
            </media-content>
        </banner>
    </div>
</template>

<script>
import common from '../index.js';
import MediaContent from '../../../components/media-content.vue';
import BannerButton from '../../../components/banner-button.vue';
import SearchGroup from './search-group.vue';
export default {
    data: function() {
        return {
            priceInterval: [0, [20, 10000], [32, 25000], [90, 100000]]
        };
    },
    mixins: [common],
    components: {
        MediaContent,
        BannerButton,
        SearchGroup
    },
    computed: {
        titleAlign() {
            let match = this.title.match(/text-align:(.*?);/);
            if (match) {
                return match[1].trim();
            }
            return 'left';
        }
    },
    created() {
        this.renderSwiperPagination();
    },
    methods: {
        renderSwiperPagination() {
            if (this.pictureListOption) {
                let opt = this.pictureListOption.swiperOption || {};
                this.pictureListOption.swiperOption = opt;
            }
            if (this.mobilePictureListOption) {
                let opt = this.mobilePictureListOption.swiperOption || {};
                this.mobilePictureListOption.swiperOption = opt;
            }
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

@mixin title-text {
    .title-text {
        .media-title {
            font-size: 30px;
            line-height: 1.36;
        }

        .media-subtitle {
            font-size: 20px;
            line-height: 1.5;
        }
    }
}

.md-hero.broker {
    &.banner-with-search-bar {
        @include media-1080 {
            .banner-video.autoplay {
                padding-bottom: 66px;
            }
            .media-content {
                position: static;
                margin-bottom: 50px;

                @include title-text;

                .search-bar {
                    margin-top: 0;
                    margin-bottom: 0;
                    position: absolute;
                    padding: 15px;
                    bottom: 0;
                    > .title,
                    .condition-search {
                        display: none;
                    }
                    .keyword-submit {
                        background-color: white;
                        color: #a0a1b4;
                    }
                    .search-by-section .search-category {
                        margin-top: 0;
                    }
                }
            }
        }
    }

    &.banner-with-search-group {
        @include media-800 {
            .media-content {
                @include title-text;
                .search-group {
                    margin-top: 40px;
                    padding: 15px 0;
                }
            }
        }
    }

    &.banner-with-search-btn {
        .banner-button {
            width: 100%;
            flex-direction: row;
            justify-content: center;
            &.count-4 {
                max-width: 900px;
            }
            @include media-min-1080 {
                &.row {
                    width: 50%;
                    flex-direction: column;
                    align-items: flex-end;
                    .btn-item {
                        width: 400px;
                    }
                }
            }
            .btn-item {
                min-width: 280px;
                height: 50px;
                line-height: 48px;
                font-family: var(--mg-button-font);
                font-size: 16px;
                box-shadow: none;
                margin: 30px 15px 0;
                padding: 0 15px;
                border-radius: 5px;
                box-shadow: 0 2px 8px 0 rgba(28, 29, 32, 0.2);
                border: solid 2px #ffffff;
                color: #ffffff;
                background: transparent;
                position: relative;
                &:hover {
                    &:after {
                        content: '';
                        bottom: 0;
                        top: 0;
                        left: 0;
                        right: 0;
                        position: absolute;
                        background: rgba(255, 255, 255, 0.15);
                    }
                }
            }
            @include media-800 {
                display: inline-block;
                width: 100%;
                .btn-item {
                    width: 100%;
                    min-width: 220px;
                    margin: 0;
                    height: 40px;
                    line-height: 38px;
                    margin-top: 20px;
                }
            }
        }
    }

    .media-content {
        z-index: calc(var(--level-sublow) + 1);
        @include media-min-1080 {
            &.row {
                width: 1420px;
                .title-text:before {
                    left: 0;
                    transform: none;
                }
            }
        }
        .media-info {
            width: 100%;
            max-width: 100%;
        }
        .title-text {
            padding-top: 0;
            position: relative;
            &:before {
                content: none; // The product has requested to be deleted again
                width: 98px;
                height: 6px;
                box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.22);
                @include color-theme('background-color');
                position: absolute;
                top: -40px;
                left: 50%;
                transform: translateX(-50%);
            }
            .media-title {
                word-break: break-word;
                text-shadow: 0 3px 1px rgba(0, 0, 0, 0.39);
                line-height: 1.36;
            }
            .media-subtitle {
                overflow: hidden;
                line-height: 1.5;
                margin-top: 30px;
                text-shadow: 0 1px 1px rgba(8, 17, 38, 0.8);
            }
            .media-shadow {
                display: none;
            }
        }
        &.align-left {
            .title-text:before {
                left: 0;
                transform: none;
            }
        }
        &.align-right {
            .title-text:before {
                left: auto;
                right: 0;
                transform: none;
            }
        }
        &.align-center {
            .title-text:before {
                left: 50%;
                transform: translateX(-50%);
            }
        }
        &.media-content-search-btn,
        &.media-content-search-group {
            .title-text .media-shadow {
                display: none;
            }
        }
        @include media-1080 {
            max-width: calc(100% - 80px);
            .title-text {
                .media-title {
                    font-size: 38px;
                    line-height: 45px;
                }
                .media-subtitle {
                    font-size: 17px;
                }
            }
            .btn-item {
                min-width: 168px;
                padding: 0 10px;
                height: 32px;
                line-height: 30px;
                text-shadow: none;
            }
        }

        @include media-600 {
            max-width: calc(100% - 30px);
            .title-text {
                padding: 0;
                &:before {
                    width: 40px;
                    height: 3px;
                    top: -13px;
                    left: 0;
                    transform: none;
                }
                .media-title {
                    font-size: 24px;
                    line-height: 26px;
                }
                .media-subtitle {
                    margin: 8px auto 0;
                    font-size: 14px;
                }
                .media-shadow {
                    width: 300px;
                    top: 16px;
                }
            }
            .banner-button {
                margin-top: 18px;
            }
            .btn-item {
                min-width: 154px;
                padding: 0 5px;
                height: 26px;
                line-height: 24px;
            }
        }
    }
    .banner-video + .media-content {
        @include media-min-1080 {
            &.row {
                .play-video {
                    margin: 20px auto;
                }
            }
        }
        .play-video {
            width: 80px;
            height: 80px;
            border: 4px solid white;
            border-radius: 50%;
            position: relative;
            margin: 20px auto;
            cursor: pointer;
            pointer-events: all;
            &:after {
                content: '';
                position: absolute;
                top: 50%;
                left: 24px;
                transform: translateY(-50%);
                border-top: 20px solid transparent;
                border-bottom: 20px solid transparent;
                border-left: 30px solid white;
            }
            @include media-1080 {
                width: 60px;
                height: 60px;
                &:after {
                    left: 16px;
                }
            }
            @include media-600 {
                width: 40px;
                height: 40px;
                &:after {
                    left: 10px;
                    border-top: 10px solid transparent;
                    border-bottom: 10px solid transparent;
                    border-left: 15px solid white;
                }
            }
        }
        .video-loading {
            display: none;
            width: 108px;
            height: 108px;
            background: url(//static.chimeroi.com/site/images/home/loading.gif)
                no-repeat;
            background-size: cover;
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
    }
    .banner-video.autoplay + .media-content,
    .banner-video.is-play + .media-content {
        .video-loading {
            display: none;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.loading + .media-content {
        .video-loading {
            display: block;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.is-play ~ .banner-mask {
        display: none;
    }
    .media-content-box {
        width: 100%;
    }
    .banner-video {
        .play-video,
        .video-loading {
            display: none;
        }
    }
    .swiper-horizontal > .swiper-pagination-bullets {
        bottom: 25px;
        .swiper-pagination-bullet {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin-left: 10px;
            margin-right: 10px;
            @include color-theme('background-color');
            opacity: 1;
        }
    }
    .swiper-pagination {
        text-align: left;
        padding-left: 30px;
        bottom: 30px;
        .broker-hero-pagination-bullet {
            width: 50px;
            height: 1px;
            background-color: #ffffff;
            display: inline-block;
            &.active {
                height: 2px;
                background-color: var(--color-theme);
            }
        }
        .broker-hero-custom-pagination-number {
            display: block;
            font-family: var(--font-bold);
        }
        @include media-600 {
            padding-left: 20px;
        }
    }
    .keyword-submit {
        position: relative;
    }
}
</style>
